/** Feature-local TanStack QueryClient per admin-listino (F-009.4). */
import { QueryClient } from '@tanstack/react-query';

export function createListinoQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: { staleTime: 30_000, retry: 1, refetchOnWindowFocus: false },
      mutations: { retry: 0 },
    },
  });
}

export const listinoQueryClient = createListinoQueryClient();
export const listinoQueryKey = ['admin', 'listino'] as const;
